import React from 'react';
import './Reset.css';
import './App.css';
import Header from './components/header/Header';
import Main from './components/main/Main';
import Footer from './components/footer/Footer';
// import Js from './js/Js';

function App() {
  return (
    <div className ="App">
      <Header/>
      <Main/>
      <Footer/>
    </div>
  );
}

export default App;
